/**
 * Sesión: registro del handler global de 401.
 *
 * Vive en su propio módulo (sin imports) para que el cliente HTTP pueda avisar de un 401
 * sin depender del store ni de TanStack Query (evita ciclos de importación). El wiring real
 * —limpiar la sesión y vaciar la caché de queries— se registra una sola vez en
 * `src/lib/session-guard.ts`, llamado desde `main.tsx` antes de renderizar.
 */

export type UnauthorizedHandler = () => void;

let handler: UnauthorizedHandler | null = null;

/** Registra qué hacer cuando el backend responde 401 (token inválido/expirado). */
export function setUnauthorizedHandler(next: UnauthorizedHandler): void {
  handler = next;
}

/** Lo llama el cliente HTTP ante un 401. */
export function handleUnauthorized(): void {
  handler?.();
}
